<template>
	<div class="order-list-page" v-loading="isLoading">
		<el-tabs v-model="tabName">
			<el-tab-pane label="全部订单" name="all">
				<order-content :tabName="tabName" @loading="loading" @refreshGroupOrder="getOrderGroups"></order-content>
			</el-tab-pane>
			<el-tab-pane name="000">
				<span slot="label">
					待付款
					<div class="tag" v-if="orderGroups['000']">{{ orderGroups['000'] }}</div>
				</span>
				<order-content status="000" :tabName="tabName" @loading="loading" @refreshGroupOrder="getOrderGroups"></order-content>
			</el-tab-pane>
			<el-tab-pane name="101">
				<span slot="label">
					待发货
					<div class="tag" v-if="orderGroups['101']">{{ orderGroups['101'] }}</div>
				</span>
				<order-content status="101" :tabName="tabName" @loading="loading" @refreshGroupOrder="getOrderGroups"></order-content>
			</el-tab-pane>
			<el-tab-pane name="301">
				<span slot="label">
					已发货
					<div class="tag" v-if="orderGroups['301']">{{ orderGroups['301'] }}</div>
				</span>
				<order-content status="301" :tabName="tabName" @loading="loading" @refreshGroupOrder="getOrderGroups"></order-content>
			</el-tab-pane>
			<el-tab-pane name="501">
				<span slot="label">
					已收货
					<div class="tag" v-if="orderGroups['501']">{{ orderGroups['501'] }}</div>
				</span>
				<order-content status="501" :tabName="tabName" @loading="loading" @refreshGroupOrder="getOrderGroups"></order-content>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import { getOrderGroups } from '@/api/order.js';
	import OrderContent from './orderContent.vue'
	
	export default {
		name: 'order-list',
		components: {
			OrderContent
		},
		data() {
			return {
				isLoading: false,
				tabName: 'all',
				orderGroups: {}
			};
		},
		beforeMount() {
			this.getOrderGroups();
			
			if (this.$route.query && this.$route.query.tabName) {
				this.tabName = this.$route.query.tabName;
			}
		},
		methods: {
			loading(e) {
				this.isLoading = e;
			},
			
			getOrderGroups() {
				getOrderGroups().then(res => {
					if (res && res.code == '0') {
						this.orderGroups = res.data;
					}
				});
			}
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";
	
	.order-list-page {
		min-height: 386px;
		
		.el-tabs  {
			.el-tabs__header {
				margin: 0 0 10px;
				padding-left: 20px;
				height: 60px;
				background: #FFFFFF;
				border-radius: 8px;
				
				.el-tabs__nav-wrap::after {
					content: none;
				}
				
				.el-tabs__item {
					position: relative;
					padding: 0 30px;
					height: 60px;
					line-height: 60px;
					color: $fontColor;
					
					.tag {
						position: absolute;
						top: 15px;
						left: 75px;
						padding: 0 6px;
						height: 16px;
						line-height: 16px;
						background: #F43232;
						border-radius: 8px;
						font-size: 13px;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
				
				.is-top:nth-child(2) {
					padding-left: 0 !important;
				}
				
				.is-active {
					font-weight: bold;
				}
			}
		}
	}
</style>
